var map = {
	"./emoji_00.png": "32f0",
	"./emoji_01.png": "953f",
	"./emoji_02.png": "7548",
	"./emoji_03.png": "43ac",
	"./emoji_04.png": "9f43",
	"./emoji_05.png": "2127",
	"./emoji_06.png": "9bee",
	"./emoji_07.png": "3454",
	"./emoji_08.png": "9502",
	"./emoji_09.png": "c3df",
	"./emoji_10.png": "f99ff",
	"./emoji_11.png": "8fe5",
	"./emoji_12.png": "100d",
	"./emoji_13.png": "81db",
	"./emoji_14.png": "2157",
	"./emoji_15.png": "957f",
	"./emoji_16.png": "bbe5",
	"./emoji_17.png": "bf9c",
	"./emoji_18.png": "b175",
	"./emoji_19.png": "a49c",
	"./emoji_20.png": "a3ef",
	"./emoji_21.png": "9e4d",
	"./emoji_22.png": "c6bf",
	"./emoji_23.png": "7c06",
	"./emoji_24.png": "0be7",
	"./emoji_25.png": "f479",
	"./emoji_26.png": "98d4",
	"./emoji_27.png": "3f2d",
	"./emoji_28.png": "c5b5",
	"./emoji_29.png": "a25a",
	"./emoji_30.png": "9f60",
	"./emoji_31.png": "5f06",
	"./emoji_32.png": "a209",
	"./emoji_33.png": "900e",
	"./emoji_34.png": "993e",
	"./emoji_35.png": "c650",
	"./emoji_36.png": "fe20",
	"./emoji_37.png": "2460",
	"./emoji_38.png": "1eb1",
	"./emoji_39.png": "6604",
	"./emoji_40.png": "be10",
	"./emoji_41.png": "146d",
	"./emoji_42.png": "f6e5",
	"./emoji_43.png": "3190",
	"./emoji_44.png": "a93b",
	"./emoji_45.png": "dca3",
	"./emoji_46.png": "4e44",
	"./emoji_47.png": "06a4",
	"./emoji_48.png": "6b0c",
	"./emoji_49.png": "8964",
	"./emoji_50.png": "a1e1",
	"./emoji_51.png": "6f50",
	"./emoji_52.png": "8c98",
	"./emoji_53.png": "b28d",
	"./emoji_54.png": "5c7a",
	"./emoji_55.png": "1264",
	"./emoji_56.png": "52a4",
	"./emoji_57.png": "87aa",
	"./emoji_58.png": "3b38",
	"./emoji_59.png": "41f5",
	"./emoji_60.png": "ce4e",
	"./emoji_61.png": "f095",
	"./emoji_62.png": "af2d",
	"./emoji_63.png": "6fd2",
	"./emoji_64.png": "7598",
	"./emoji_65.png": "e2fe",
	"./emoji_66.png": "4aef",
	"./emoji_67.png": "9727",
	"./emoji_68.png": "1a35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04ca";